import React, { useState } from "react";
import InputField from "../../../components/InputField";
import HandleInputChange from "../../../utils/HandleInputChange";
import CreateRegionAPI from "../api/CreateRegionAPI";
import AlertComponent from "../../../components/AlertComponent";
import ErrorAlert from "../../../components/ErrorAlert";

const CreateRegionForm = () => {
  // variable
  const [formData, setFormData] = useState({
    regionName: "",
    minQty: 0,
  });
  const [alert, setAlert] = useState("null");

  //   handler for create new region
  const createRegionHandler = async (e) => {
    e.preventDefault();
    let response = await CreateRegionAPI(formData);
    response ? setAlert("created") : setAlert("error");
    setTimeout(() => {
      setAlert("null");
    }, 5000);
  };

  return (
    <>
      {alert === "error" ? (
        <ErrorAlert
          title={"فشل في عملية إضافة المنطقة"}
          content={"حدث خطا في عملية إضافة منطقة جديدة"}
        />
      ) : alert === "created" ? (
        <AlertComponent
          title={" تمت إضافة المنطقة بنجاح"}
          content={`تمت إضافة المنطقة ${formData.regionName} مع الحد الإدني ${formData.minQty} بنجاح`}
        />
      ) : (
        ""
      )}
      <form className="w-full" onSubmit={createRegionHandler}>
        <InputField
          name="regionName"
          label="إسم المنطقة"
          dir="rtl"
          value={formData.regionName}
          onChange={(e) => {
            HandleInputChange(e, setFormData);
          }}
        />
        <InputField
          name="minQty"
          label="الحد الإدني من الطلبات لهذه المنطقة"
          type="number"
          dir="rtl"
          value={formData.minQty}
          onChange={(e) => {
            HandleInputChange(e, setFormData);
          }}
          min="0"
        />

        <button
          type="submit"
          className="rounded border-0 bg-indigo-500 px-6 py-2 text-lg text-white hover:bg-indigo-600 focus:outline-none"
        >
          إضافة
        </button>
      </form>
    </>
  );
};

export default CreateRegionForm;
